import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { LoadingService } from '../../services/loading.service';
import { SectionStateStatus } from "@shared/enums/section-state-status.enum";


@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  @ViewChild('loadingOverlayPage', { static: true }) loadingOverlayPage: ElementRef;
  isHidden$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  constructor(
    private renderer: Renderer2,
    private loadingService: LoadingService
  ) { }

  ngOnInit() {
    this.loadingService.loadingStatus$.subscribe((status: SectionStateStatus) => {
      switch (status) {
        case SectionStateStatus.HideLoading:
          this.hide();
          break;

        case SectionStateStatus.Loading:
          this.showNotTransparent();
          break;

        case SectionStateStatus.LoadingTransparent:
          this.showTransparent();
          break;
      }
    });
  }

  showNotTransparent() {
    this.renderer.setStyle(
      this.loadingOverlayPage.nativeElement,
      'background',
      '#FFFFFF'
    );
    this.isHidden$.next(false);
  }

  showTransparent() {
    this.renderer.setStyle(
      this.loadingOverlayPage.nativeElement,
      'background',
      '#40404033'
    );
    this.isHidden$.next(false);
  }

  hide() {
    this.isHidden$.next(true);
    this.renderer.addClass(this.loadingOverlayPage.nativeElement, 'hidden');
  }
}
